"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
const PendingChargeValidator_1 = __importDefault(require("./PendingChargeValidator"));
class UpdatePendingChargeValidator extends GenericValidator_1.default {
    _pendingChargeValidator;
    constructor(_pendingChargeValidator = new PendingChargeValidator_1.default()) {
        super();
        this._pendingChargeValidator = _pendingChargeValidator;
    }
    _schema = joi_1.default.object({
        note: joi_1.default.string().required(),
        charge: joi_1.default.object().required(),
    }).required();
    validate(input) {
        const joiResult = this._schema.validate(input, {
            abortEarly: false,
            convert: false,
        });
        const issues = this.handleIssues(joiResult, 'IUpdatePendingCharge');
        const chargeIssues = this._pendingChargeValidator.validateAndHandleIssues(input.charge, '$.charge');
        issues.push(...chargeIssues);
        this.processErrors(issues);
    }
}
exports.default = UpdatePendingChargeValidator;
